import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

import { Observable } from 'rxjs';

import {
    type CatalogObject,
    CatalogObjectSelection,
    CatalogObjectTypesEnum,
    IconDetail,
    JobSite,
    Layer,
    Project,
    ProjectType,
    SubMenuOption,
} from '@mirage-projects/cw-models';

import { CardService } from './card.service';

@Component({
    selector: 'cw-card',
    templateUrl: './card.component.html',
    styleUrls: ['./card.component.scss'],
    standalone: false,
})
export class CardComponent implements OnInit, OnChanges {
    /** input to have the catalogObject Data   */
    @Input() catalogObject!: CatalogObject;
    /** input to know if the card layout is vertical or orizontal */
    @Input() isVertical = true;
    /** Selects or unselects the card */
    @Input() checked = false;
    /** Input to have the data of the icons and number of projects */
    @Input() iconDetail: IconDetail[] | undefined;
    /** input to have the data of secondary menu options */
    @Input() cardSecondaryMenuOptions: SubMenuOption[] | undefined;
    /** Sets dashboard mode */
    @Input() isDashboard = false;
    /** Sets if the card should show the checkbox or not, not set means default behaviour */
    @Input() shouldShowCheckbox?: boolean;

    /** Event emitted when the user clicks on the close icon */
    @Output() secondaryMenuClick = new EventEmitter<SubMenuOption>();
    /** Event emitted when the user clicks on the image card or text card */
    @Output() objectClick = new EventEmitter<CatalogObjectSelection>();
    /** Event emitted when the user clicks on the card checkbox */
    @Output() cardCheck: EventEmitter<CatalogObjectSelection> = new EventEmitter<CatalogObjectSelection>();

    layerData: Layer | undefined;
    projectData: Project | undefined;
    jobSiteData: JobSite | undefined;
    thumbnail!: Observable<string>;

    constructor(public cardService: CardService) {}

    ngOnInit(): void {
        this.getData();

        this.thumbnail = this.cardService.getThumbnailUrl(this.catalogObject.thumbnail ?? '');
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['catalogObject']) {
            this.getData();
        }
    }
    get isLayer(): boolean {
        return !!this.layerData;
    }

    get isProject(): boolean {
        return !!this.projectData;
    }

    get isJobSiteProject(): boolean {
        return !!this.jobSiteData;
    }

    get isCheckboxVisible(): boolean {
        // Todo: Think about moving this logic to the card model
        if (typeof this.shouldShowCheckbox !== 'boolean') {
            return !this.isJobSiteProject;
        }
        return this.shouldShowCheckbox;
    }

    get isScan(): boolean {
        return this.projectData?.projectType === ProjectType.SCAN;
    }

    get isDefaultProjectType(): boolean {
        return this.projectData?.projectType === ProjectType.COLLAGE_TYPE;
    }

    get projectsCount(): string | number {
        return !this.layerData || this.layerData.projectsCount < 0 ? '-' : this.layerData?.projectsCount;
    }

    onSecondaryMenuClicked(menuOption: SubMenuOption): void {
        this.secondaryMenuClick.emit(menuOption);
    }

    onClickObject(): void {
        this.checked = !this.checked;
        this.objectClick.emit({ catalogObject: this.catalogObject, selected: this.checked });
    }

    cardSelect(item: CatalogObject): void {
        this.cardCheck.emit({ catalogObject: item, selected: this.checked });
    }

    updateDataRequest(): void {
        this.getData();
    }

    getData(): void {
        if (this.catalogObject?.type === CatalogObjectTypesEnum.layers) {
            this.layerData = this.catalogObject as Layer;
        }
        if (this.catalogObject?.type === CatalogObjectTypesEnum.projects) {
            this.projectData = this.catalogObject as Project;
        }
        if (this.catalogObject?.type === CatalogObjectTypesEnum.jobSites) {
            this.jobSiteData = this.catalogObject as JobSite;
        }
    }

    get accessedAt(): Date | null {
        return this.catalogObject.accessedAt;
    }
}
